import { css as r } from "@microsoft/fast-element";
import { normalize as e } from "../../common/normalize.js";
import { display as l } from "@matrix42/fast-foundation";
import { designTokens as o } from "../../design-tokens.js";
import { typography as t } from "../../styles/typography.js";
const d = r`
  ${e}
  ${l("inline-flex")}
  :host {
    /* Base */
    outline: none;
    user-select: none;
    vertical-align: top;
    /* Layout */
    align-items: center;
    gap: ${o.spacing[2]};
  }

  :host(:focus-visible) .control {
    /* Style */
    outline: ${o.borderWidth.sm} solid ${o.color.black};
    outline-offset: ${o.borderWidth.sm};
  }

  :host(.checked) slot[name='checked-indicator'] {
    /* Base */
    display: contents;
  }

  :host(.checked) .control {
    /* Style */
    border-color: ${o.color.primary[100]};
    background-color: ${o.color.primary[100]};
  }

  :host(:hover) .control {
    /* Style */
    border-color: ${o.color.primary[200]};
  }

  :host(.checked:hover) .control {
    /* Style */
    background-color: ${o.color.primary[200]};
  }

  :host(:active) .control {
    /* Style */
    border-color: ${o.color.primary[500]};
  }

  :host(.checked:active) .control {
    /* Style */
    background-color: ${o.color.primary[500]};
  }

  :host(:disabled) .control {
    /* Style */
    border-color: ${o.color.neutral[70]};
  }

  :host(.checked:disabled) .control {
    /* Style */
    background-color: ${o.color.neutral[70]};
  }

  :host(:disabled) .label {
    /* Style */
    color: ${o.color.neutral[70]};
  }

  .control {
    /* Layout */
    display: inline-flex;
    width: ${o.spacing[4]};
    height: ${o.spacing[4]};
    align-items: center;
    justify-content: center;
    /* Style */
    border-radius: ${o.borderRadius.full};
    border: ${o.borderWidth.xs} solid
      ${o.color.neutral[200]};
    background-color: ${o.color.white};
  }

  slot[name='checked-indicator'] {
    /* Base */
    display: none;
  }

  .indicator {
    /* Base */
    display: inline-flex;
    /* Layout */
    width: ${o.spacing["1.5"]};
    height: ${o.spacing["1.5"]};
    /* Style */
    border-radius: ${o.borderRadius.full};
    background-color: ${o.color.white};
  }

  .label {
    /* Style */
    color: ${o.color.neutral[500]};
    /* Typography */
    ${t("p", "regular")}
  }
`;
export {
  d as radioGroupOptionStyles
};
